import React from 'react';
import { CalendarPlaceholderSC } from './calendar-placeholder.styled';
import { S, pipe } from '@mobily/ts-belt';
import { TFormVariant } from '../../../form/Form.types';
import classNames from 'classnames';

interface CalendarPlaceholderProps {
  value?: string;
  style?: React.CSSProperties;
  className?: string;
  placeholder?: string;
  variant?: TFormVariant;
}

const CalendarPlaceholder: React.FunctionComponent<CalendarPlaceholderProps> = ({
  value = '',
  placeholder = '',
  style,
  className,
  variant,
}) => {
  const [, post] = pipe(placeholder, S.splitAt(value.length));

  return (
    <CalendarPlaceholderSC
      style={style}
      className={classNames(className, variant)}
      display="body2"
      variant="strong"
    >
      <span style={{ visibility: 'hidden' }} className="value-placeholder">
        {value}
      </span>
      <span className="value-placeholder">{post}</span>
    </CalendarPlaceholderSC>
  );
};

export default CalendarPlaceholder;
